/**
 * @author caijianjia
 * @date 2020/3/28 10:46 上午
 */

 import store from '../store'
 import request from '../config/network/requestUcenterApiService'
 import {apiUpdate} from './localdata'
 //import {getHash} from '../utils/utils'

// --------------------游戏分类开始------------------------------
/**
 * 游戏分类管理
 */

// 新建游戏分类 - C端
export function addGameCategory ({
  type = 'client',
  parentId = 0,
  name,
  description
}) {
  return request({
    url: 'api/courseware/game-category',
    method: 'post',
    data: {
      type,
      parent_id: parentId,
      name,
      description
    }
  })
}

// 新建游戏分类 - 双师
export function addGameCategoryDouble ({
  type = 'double_teacher',
  parentId = 0,
  name,
  description
}) {
  return request({
    url: 'api/courseware/game-category',
    method: 'post',
    data: {
      type,
      parent_id: parentId,
      name,
      description
    }
  })
}

// 删除游戏分类
export function deleteGameCategory ({ id, clientsId }) {
  return request({
    url: `api/courseware/game-category/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改游戏分类
export function updateGameCategory ({
  id,
  clientsId,
  sort,
  parentId = 0,
  name
}) {
  return request({
    url: `api/courseware/game-category/${id}?clients_id=${clientsId}`,
    method: 'put',
    data: {
      clients_id: clientsId,
      sort,
      parent_id: parentId,
      name
    }
  })
}

// 获取游戏分类树
export async function getGameCategoryTree ({
  clientsId
}) {
  let key="getGameCategoryTree_"+clientsId+"_1";
  if(store.state.cacheList[key]){
    console.log(key,store.state.cacheList);
    res=store.state.cacheList[key];
  }else{
    const res = request({
      url: 'api/courseware/game-category/tree?is_show=1',
      method: 'get',
      params: {
        clients_id: clientsId
      }
    })
    store.state.cacheList[key]=res;
  }

  return Promise.resolve({ data: res.data.client && !Array.isArray(res.data.client) ? [res.data.client] : res.data.client })
}

// 获取游戏分类树 - 双师
export async function getGameCategoryTreeDouble ({
  clientsId
}) {
  let key="getGameCategoryTreeDouble_"+clientsId+"_1";
  if(store.state.cacheList[key]){
    let res=store.state.cacheList[key];
    return Promise.resolve({ data: res.data.double_teacher && !Array.isArray(res.data.double_teacher) ? [res.data.double_teacher] : res.data.double_teacher })
  }
  const res = await request({
    url: 'api/courseware/game-category/tree?is_show=1',
    method: 'get',
    params: {
      clients_id: clientsId
    }
  })
  store.state.cacheList[key]=res;
  return Promise.resolve({ data: res.data.double_teacher && !Array.isArray(res.data.double_teacher) ? [res.data.double_teacher] : res.data.double_teacher })
}
// --------------------游戏分类结束------------------------------

/**
 * 游戏管理
 */

// 新建游戏
export function addGame ({
  categoryId = 0,
  name,
  alias,
  mark,
  questionType,
  cover,
  formId,
  description
}) {
  return request({
    url: 'api/courseware/game',
    method: 'post',
    data: {
      category_id: categoryId,
      name,
      alias,
      mark,
      question_type: questionType,
      cover,
      form_id: formId,
      description
    }
  })
}

// 删除游戏
export function deleteGame ({ id }) {
  return request({
    url: `api/courseware/game/${id}`,
    method: 'delete'
  })
}

// 修改游戏
export function updateGame ({
  id,
  categoryId = 0,
  name,
  alias,
  mark,
  questionType,
  cover,
  formId,
  description
}) {
  return request({
    url: `api/courseware/game/${id}`,
    method: 'put',
    data: {
      category_id: categoryId,
      name,
      alias,
      mark,
      question_type: questionType,
      cover,
      form_id: formId,
      description
    }
  })
}

// 获取游戏列表
export async function getGameList ({
  id,
  search,
  categoryId,
  page,
  classType,
  gtype,
  is_push,
  gameType
}) {
  let url = 'api/courseware/game?'
  if (search) url += `&like[name]=${search}`
  if (classType) url += `&like[is_${classType}]=1`
  if (is_push) url += `&equal[is_push]=${is_push}`
  if (gameType) url += `&equal[${gameType}]=1`
  if (!gameType) url+='&in_class_type=in_class';

  let key="getGameList"+((search)?'_name_'+search:'')+((classType)?'_is_'+classType:'')+((is_push)?'_is_'+is_push:'')+((gameType)?'_'+gameType:'')+((!gameType)?'_in_class':'')+((categoryId!==undefined)?"_"+categoryId:'')+((id!==undefined)?"_"+id:'')+"_"+gtype+"_"+page;
  let cacheData=await store.state.cacheList[key];

  console.log("key",key);
  if(cacheData){
    cacheData.cache=1;
    return cacheData;
  }

  let res = await request({
    url,
    method: 'get',
    params: {
      'equal[category_id]': categoryId,
      'equal[id]': id,
      'equal[gtype]': gtype,
      page
    }
  })
  res.cache=0;
  store.state.cacheList[key]=res;
  return res
}

// 获取游戏详情
export function getGameDetail ({ id }) {
  return request({
    url: `api/courseware/game/${id}`,
    method: 'get'
  })
}

/**
 * 游戏练习
 */

// 添加游戏练习
export function addExerciseGame ({
 clientsId,
 categoryId,
 name,
 ...params
}) {
  return request({
    url: `api/courseware/exercise-game`,
    method: 'post',
    data: {
      clients_id: clientsId,
      category_id: categoryId,
      name,
      ...params
    }
  })
}

// 保存游戏配置
// clients_id	string	校区id
// name	string	标题
// result_id string 课件id
// attributes.h5_original	string	h5原始配置
// attributes.h5_remote	string	H5配置-远程
// attributes.cocos_original	string	cocos原始配置
// attributes.cocos_remote	string	cocos远程
// attributes.cocos_local	string	cocos本地
export function updateExerciseGame ({
 clientsId,
 categoryId,
 name,
 id,
 result_id,
 method,
 noLock,
 attributes,
 ...params
}) {
  console.log("修改游戏练习！！！修改游戏练习！！！修改游戏练习！！！修改游戏练习！！！修改游戏练习！！！");
  return apiUpdate({
    url: `api/courseware/exercise-game/${id}`,
    method: method || 'put',
    noLock,
    data: {
      clients_id: clientsId,
      category_id: categoryId,
      name,
      result_id,
      attributes,
      ...params
    }
  },id)
}

// 游戏练习详情
export function queryExerciseGameDetail ({
 id,
 clientsId,
 config_type
}) {
  return request({
    url: `api/courseware/exercise-game/${id}?clients_id=${clientsId}`,
    method: 'get',
    params: {
      config_type
    }
  })
}

// 游戏练习打包
export function packetExerciseGame({
 id,
 clientsId,
 cocos_remote
}) {
  return request({
    url: `api/courseware/exercise-game/${id}/packet?clients_id=${clientsId}`,
    method: 'post',
    data: {
      cocos_remote
    }
  })
}

// 游戏练习打包进度
export function packetExerciseGameStatus({
 practiceId,
 attrId
}) {
  return request({
    url: `api/courseware/exercise-game/${practiceId}/${attrId}/packet-status`,
    method: 'get'
  })
}

// 获取游戏练习配置 - 通过版本号
export function queryExerciseGameVersion({
 practiceId,
 version
}) {
  return request({
    url: `api/courseware/exercise-game-attr-version/${practiceId}/${version}`,
    method: 'get'
  })
}
